import { render } from "./EmployeeServiceReportApprovalHistory.vue?vue&type=template&id=6a6e174b"
import script from "./EmployeeServiceReportApprovalHistory.vue?vue&type=script&lang=js"
export * from "./EmployeeServiceReportApprovalHistory.vue?vue&type=script&lang=js"

import "./EmployeeServiceReportApprovalHistory.vue?vue&type=style&index=0&id=6a6e174b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__